module.exports = __webpack_public_path__ + "static/media/advGame_opt.5165e98b.jpg";